/** Boss behavior phases for the Echo fight. */
export enum EchoBossPhase {
  Asleep = "Asleep",
  Scream = "Scream",
  Chase = "Chase",
  Transforming = "Transforming",
  Phase_1 = "Phase_1",
  Phase_2 = "Phase_2",
  Phase_3 = "Phase_3",
  Defeated = "Defeated"
}

/** Animation names available on the Echo Spine skeleton. */
export enum EchoAnimation {
  Animation = "animation",
  BigCannonShootDown = "Big_cannon_shoot_down",
  BigCannonShootFront = "Big_cannon_shoot_front",
  BigCannonShootUp = "Big_cannon_shoot_up",
  Death = "death",
  Idle = "Idle",
  Idle2 = "Idle2",
  Lunge = "Lunge",
  PlayerTrapped = "player_trapped",
  Scream = "Scream",
  ShortCannonShoot = "Short_cannon_shoot",
  Transform = "Transform",
  Transform2 = "Transform2",
  Transform3 = "Transform3",
  WalkAggressively = "Walk agresevely",
  WalkAttackMode = "Walk_attack_mode",
  WalkBackwards = "Walk_backwards",
  WalkNew = "Wulk new"
}

/** Bone names in the Echo Spine skeleton. */
export enum EchoBone {
  Root = "root",
  Body2 = "Images/body2",
  Neck = "Images/Neck",
  Head = "Images/Head",
  Leg1Fr = "leg1_fr",
  Leg4 = "Images/Leg_4",
  TargetLegFr1 = "target_leg_fr_1",
  Leg6 = "Images/Leg_6",
  Leg2Fr = "leg2_fr",
  Leg8 = "Images/Leg_8",
  TargetLegFr2 = "target_leg_fr_2",
  Leg9 = "Images/Leg_9",
  Leg3Fr = "leg3_fr",
  Leg5 = "Images/Leg_5",
  TargetLegFr3 = "target_leg_fr_3",
  Leg10 = "Images/Leg_10",
  Leg1Bc = "Leg1_bc",
  Leg2Bc = "Leg2_bc",
  Leg15 = "Images/Leg_15",
  TargLegBc2 = "targ_leg_bc_2",
  Leg16 = "Images/Leg_16",
  Leg3Bc = "Leg3_bc",
  Leg21 = "Images/Leg_21",
  TargLegBc3 = "targ_leg_bc_3",
  Leg22 = "Images/Leg_22",
  Leg23 = "Images/Leg_23",
  TargLegBc1 = "targ_leg_bc_1",
  Leg24 = "Images/Leg_24",
  ArmFr = "Arm_fr",
  Arm8_3 = "Images/Arm8_3",
  Arm8_5 = "Images/Arm8_5",
  ArmBc = "Arm_bc",
  Arm8_4 = "Images/Arm8_4",
  Arm8_6 = "Images/Arm8_6",
  Body3 = "Images/body3",
  Body4 = "Images/body4",
  Body5 = "Images/body5",
  BodyUp1 = "Body_up_1",
  BodyUp2 = "Body_up_2",
  BodyDown2 = "Body_down_2",
  BodyDown1 = "Body_down_1",
  BodyUp3 = "Body_up_3",
  BodyDown3 = "Body_down_3",
  Modem1Middle = "Images/modem1_midle",
  Modem1Up = "Images/modem1_up",
  Modem1Bottom = "Images/modem1_bottom",
  Modem2Up = "Images/modem2_up",
  Modem2Bottom = "Images/modem2_bottom",
  Modem3Middle = "Images/modem3_midle",
  Modem3Up = "Images/modem3_up",
  Modem3Bottom = "Images/modem3_bottom",
  WireNormal8 = "Images/Wire_normal8",
  Wire2 = "Wire_2",
  Bone30 = "bone30",
  Bone31 = "bone31",
  Bone32 = "bone32",
  WireController = "Wire_controler",
  Bone33 = "bone33",
  Bone34 = "bone34",
  Bone35 = "bone35",
  Bone36 = "bone36",
  Bone37 = "bone37",
  Bone38 = "bone38",
  Bone39 = "bone39",
  Bone40 = "bone40",
  Bone41 = "bone41",
  Bone42 = "bone42",
  Wire1 = "Wire_1",
  IkWire1Bon1 = "Ik_wire1_bon1",
  Bone3 = "bone3",
  Wire1Controller = "Wire1_controler",
  Wire3 = "Wire3",
  Bone13 = "bone13",
  Bone14 = "bone14",
  Bone15 = "bone15",
  Wire3Controller = "Wire3_controler",
  Bone16 = "bone16",
  Bone17 = "bone17",
  Bone18 = "bone18",
  Bone19 = "bone19",
  Bone20 = "bone20",
  Bone21 = "bone21",
  Bone22 = "bone22",
  Bone23 = "bone23",
  Wire5 = "Wire_5",
  IkWire5 = "ik_wire5",
  Bone26 = "bone26",
  IkWireBase = "Ik_wire_base",
  Wire5Controller = "Wire5_controller",
  Bone28 = "bone28",
  Bone29 = "bone29",
  Bone43 = "bone43",
  Bone44 = "bone44",
  Bone45 = "bone45",
  Bone46 = "bone46",
  Bone47 = "bone47",
  Bone48 = "bone48",
  Wire6 = "Wire_6",
  Wire7Bone = "Wire7",
  Wire8Bone = "Wire8",
  Target6 = "Target_6",
  Wire9 = "Wire9",
  Wire10 = "Wire10",
  Wire11 = "Wire11",
  Wire12 = "Wire12",
  Wire13 = "Wire13",
  Wire14 = "Wire14",
  Wire15 = "Wire15",
  Wire16 = "Wire16",
  Wire17 = "Wire17",
  Wire18 = "Wire18",
  Wire6Controller = "Wire6_controller",
  Wire7 = "Wire_7",
  Bone24 = "bone24",
  Bone49 = "bone49",
  Wire7Target = "wire7",
  Wire8 = "Wire_8",
  Wire9_ = "Wire_9",
  Wire10_ = "Wire_10",
  Wire11_ = "Wire_11",
  Wire12_ = "Wire_12",
  Wire13_ = "Wire_13",
  Wire14_ = "Wire_14",
  Wire15_ = "Wire_15",
  Wire7Controller = "Wire7_controller",
  Wire8_ = "Wire_8_",
  Bone50 = "bone50",
  Bone51 = "bone51",
  Wire8Target = "wire8",
  Wire8Controller = "Wire8_controller",
  Bone52 = "bone52",
  Bone53 = "bone53",
  Bone54 = "bone54",
  Bone55 = "bone55",
  Bone56 = "bone56",
  Bone57 = "bone57",
  Bone58 = "bone58",
  Bone59 = "bone59",
  Bone60 = "bone60",
  Bone61 = "bone61",
  WireN9 = "Wire_n9",
  WireN10 = "Wire_n10",
  WireN11 = "Wire_n11",
  TargetWire9 = "Taget_wire9",
  Wire9Controller = "Wire9_controller",
  WireN12 = "Wire_n12",
  WireN13 = "Wire_n13",
  WireN14 = "Wire_n14",
  WireN15 = "Wire_n15",
  WireN16 = "Wire_n16",
  WireN17 = "Wire_n17",
  WireN18 = "Wire_n18",
  WireN19 = "Wire_n19",
  WireN20 = "Wire_n20",
  WireN21 = "Wire_n21",
  Wire4 = "Wire4",
  Wire19 = "Wire19",
  Wire20 = "Wire20",
  Wire21 = "Wire21",
  Wire22 = "Wire22",
  Wire23 = "Wire23",
  Wire24 = "Wire24",
  Wire25 = "Wire25",
  TargWire1 = "targ_wire_1",
  EyesSockets = "Images/Eyes_sockets",
  WiresHead = "Images/Wires_head",
  WiresHead2 = "Images/Wires_head2",
  EyesSockets2 = "Images/Eyes_sockets2",
  BigEye = "Big_eye",
  EyesSockets3 = "Images/Eyes_sockets3",
  InnerCannon1 = "Inner_Cannon1",
  InnerCannon2 = "Inner_Cannon2",
  InnerCannon3 = "Inner_Cannon3",
  SmallCannon = "Small_cannon"
}

/** Slot (draw order layer) names in the Echo Spine skeleton. */
export enum EchoSlot {
  Leg24 = "Images-Leg_24",
  Leg23 = "Images-Leg_23",
  Leg22 = "Images-Leg_22",
  Leg18 = "Images-Leg_18",
  Leg17 = "Images-Leg_17",
  Leg16 = "Images-Leg_16",
  Leg26 = "Images-Leg_26",
  Leg25 = "Images-Leg_25",
  Leg13 = "Images-Leg_13",
  Body1 = "Images-body1",
  Leg12 = "Images-Leg_12",
  Leg11 = "Images-Leg_11",
  InnerCannon = "Images-Inner_canon",
  InnerCannon2 = "Images-Inner_canon2",
  InnerCannon1 = "Images-Inner_canon1",
  BottomBody3Back = "Images-Bottom_body_3_back",
  BottomBody3 = "Images-Bottom_body_3",
  UpperBody3Back = "Images-Upper_body_3_back",
  UpperBody3 = "Images-Upper_body_3",
  SmallCannon = "Small_cannon",
  BottomBody2Back = "Images-Bottom_body_2_back",
  BottomBody2 = "Images-Bottom_body_2",
  UpperBody2Back = "Images-Upper_body_2_back",
  UpperBody2 = "Images-Upper_body_2",
  BottomBody1Back = "Images-Bottom_body_1back",
  BottomBody1Front = "Images-Bottom_body_1front",
  UpperBody1Back = "Images-Upper_body_1_back",
  UpperBody1 = "Images-Upper_body_1",
  Modem1Bottom = "Images-modem1_bottom",
  Modem1Middle = "Images-modem1_midle",
  Modem2Bottom = "Images-modem2_bottom",
  Modem2Up = "Images-modem2_up",
  Modem3Bottom = "Images-modem3_bottom",
  Modem3Middle = "Images-modem3_midle",
  Modem3Up = "Images-modem3_up",
  Modem1Up = "Images-modem1_up",
  WireSmall1 = "Images-Wire_small1",
  WireVaryLarge1 = "Images-Wire_vary_large1",
  WireLarge1 = "Images-Wire_large1",
  WireVaryLarge2 = "Images-Wire_vary_large2",
  WireVaryLarge3 = "Images-Wire_vary_large3",
  PathWire1 = "Path_wire1",
  WireNormal1 = "Images-Wire_normal1",
  Wire3 = "wire3",
  Wire5 = "wire5",
  WireVaryLarge4 = "Images-Wire_vary_large4",
  Wire6 = "Wire6",
  WireLarge3 = "Images-Wire_large3",
  Wire7Slot = "Wire_7",
  WireVaryLarge5 = "Images-Wire_vary_large5",
  Wire8 = "wire8",
  WireVeryVeryLarge1 = "Images-Wire_very_very_large1",
  WireN9 = "Wire_n9",
  Wire1 = "Wire1",
  NeckSlot = "Images-Neck",
  Arm8_6 = "Images-Arm8_6",
  Arm8_5 = "Images-Arm8_5",
  Arm8_4 = "Images-Arm8_4",
  BaseHeadBottom = "Images-base_head_bottom",
  WiresHead = "Images-Wires_head",
  EyesSocketsBottom = "Images-Eyes_sockets_bottom",
  EyeBig = "Images-Eye_big",
  EyesSockets = "Images-Eyes_sockets",
  BaseHead = "Images-base_head",
  Gear = "Images-Gear",
  Arm8_1 = "Images-Arm8_1",
  Arm8_2 = "Images-Arm8_2",
  Arm8_3 = "Images-Arm8_3",
  WireLarge4 = "Images-Wire_large4",
  Leg10 = "Images-Leg_10",
  Leg9 = "Images-Leg_9",
  Leg8 = "Images-Leg_8",
  Leg2Fr = "leg2_fr",
  Leg6 = "Images-Leg_6",
  Leg5 = "Images-Leg_5",
  Leg4 = "Images-Leg_4"
}

/** IK constraint names in the Echo Spine skeleton. */
export enum EchoIkConstraint {
  BigEye = "Big_eye",
  Ik2 = "Ik2",
  IkWire4 = "IK_wire4",
  IkWire5 = "IK_wire5",
  IkWire6 = "IK_wire6",
  TargetWire9 = "Taget_wire9",
  TargetLegFr1 = "target_leg_fr_1",
  TargetLegFr2 = "target_leg_fr_2",
  TargetLegFr3 = "target_leg_fr_3",
  TargLegBc1 = "targ_leg_bc_1",
  TargLegBc2 = "targ_leg_bc_2",
  TargLegBc3 = "targ_leg_bc_3",
  TargWire1 = "targ_wire_1",
  Wire7 = "wire7",
  Wire8 = "wire8"
}
